import React from 'react';

export const VisaMark = ({ className = 'h-5' }) => (
  <svg viewBox="0 0 48 30" className={className} role="img" aria-label="Visa" data-testid="card-brand-visa">
    <rect width="48" height="30" rx="4" fill="#1A1F71" />
    <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="13" fill="#fff">VISA</text>
  </svg>
);

export const MastercardMark = ({ className = 'h-5' }) => (
  <svg viewBox="0 0 48 30" className={className} role="img" aria-label="Mastercard" data-testid="card-brand-mastercard">
    <rect width="48" height="30" rx="4" fill="#0B0B0B" />
    <circle cx="19.5" cy="15" r="8" fill="#EB001B" />
    <circle cx="28.5" cy="15" r="8" fill="#F79E1B" fillOpacity="0.9" />
  </svg>
);

export const CardBrands = ({ className = 'h-5' }) => (
  <span className="inline-flex items-center gap-1.5">
    <VisaMark className={className} />
    <MastercardMark className={className} />
  </span>
);
